<template>
  <div>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
		  	  	<li class="m-nav__item">
		  	  		<router-link :to="{name: 'home'}">
		  	  			<span class="m-nav__link-text">
                  <i class="m-nav__link-icon la la-home"></i>
		  	  			</span>
		  	  		</router-link>
		  	  	</li>
		  	  	<li class="m-nav__separator">
		  	  		>
		  	  	</li>
		  	  	<li class="m-nav__item">
              <router-link :to="{name: 'traffic_board'}">
		  	  			<span class="m-nav__link-text">
		  	  				{{'traffic_board' | translate | titleize}}
		  	  			</span>
              </router-link>
		  	  	</li>
            <li class="m-nav__separator">
		  	  		>
		  	  	</li>
		  	  	<li class="m-nav__item">
		  	  		<span class="m-nav__link-text">
		  	  			{{'monitoring' | translate | titleize}}
		  	  		</span>
		  	  	</li>
		  	  </ul>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="m-portlet">
        <div class="m-portlet__body align-center">
          <i class="flaticon-placeholder icon-principal"></i><br>
          <h2>{{control_point.name}}</h2>
          <div class="margin-10">
              <s-datatable :show_spinner="false" :config="datatable">
              </s-datatable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SDatatable from '@/components/layout/datatable/Datatable.vue'
let cable = null
export default {
  components: { SDatatable },
  data () {
    return {
      control_point: {},
      datatable: {}
    }
  },
  created () {
    const self = this
    this.$store.dispatch('retrieveMovementsCP', this.$route.params.id)
      .then((res) => {
        var port = window.location.port
        var url = ''
        var cable_port = '3334'
        var location = window.location.href.split('/')[2].split(':')[0]
        if (port === '3000') {
          // Desarrollo
          url = `ws://${location}:${cable_port}/cable`
        } else {
          // Producción
          url = `wss://${location}:${cable_port}/cable`
        }
        this.control_point = res.data.control_point
        cable = ActionCable.createConsumer(url)
        cable.subscriptions.create(
          'TraficBoardChannel',
          {
            connected: function () {

            },
            disconnected: function () {

            },
            received: function (data) {
              self.datatable.query = { id: self.$route.params.id, start_date: self.$route.params.start_date, end_date: self.$route.params.end_date }
              self.datatable.update = true
            }
          }
        )
      })
  },
  mounted () {
    const self = this
    const datatable = {
      url: '/api/trafic_board/control_point/movements',
      method: 'POST',
      size: 15,
      columns: [
        {
          field: 'movement_type',
          title: 'movement_type',
          template: function (row) {
            var movement_type = {
              5: {'title': self.$options.filters.capitalize('public_access'), 'class': 'm-badge--success'},
              4: {'title': self.$options.filters.capitalize('forced_access'), 'class': 'm-badge--success'},
              3: {'title': self.$options.filters.capitalize('no_access_available'), 'class': 'm-badge--danger'},
              2: {'title': self.$options.filters.capitalize('incomplete'), 'class': 'm-badge--warning'},
              1: {'title': self.$options.filters.capitalize('successful'), 'class': 'm-badge--success'}
            }
            return '<span class="m-badge ' + movement_type[row.movement_type].class + ' m-badge--wide">' + movement_type[row.movement_type].title + '</span>'
          }
        },
        {
          field: 'description',
          title: 'credential_type',
          template: function (row) {
            if (row.description === null || row.description === 'DNI') {
              return `${row.identification_type}`
            } else {
              return `${row.description}`
            }
          }
        },
        {
          field: 'credential',
          title: 'value_credential',
          template: function (row) {
            if (row.credential === null) {
              return `${row.identification_number}`
            } else {
              return `${row.credential}`
            }
          }
        },
        {
          field: 'first_name',
          title: 'full_name',
          template: function (row) {
            return `${row.first_name} ${row.last_name}`
          }
        },
        {
          field: 'way',
          title: 'sense',
          template: function (row) {
            var ways = {
              2: {'title': self.$options.filters.capitalize('out'), 'class': 'm-badge--warning'},
              1: {'title': self.$options.filters.capitalize('in'), 'class': 'm-badge--success'}
            }
            return `<span class="m-badge ${ways[row.way].class} m-badge--wide">${ways[row.way].title}</span>`
          }
        },
        {
          field: 'create_time',
          title: 'movement_date'
        }],
      actions: false,
      update: false,
      query: { id: this.$route.params.id, start_date: this.$route.params.start_date, end_date: this.$route.params.end_date }
    }
    this.datatable = datatable
  },
  beforeDestroy () {
    if (cable !== null) {
      cable.disconnect()
    }
  }
}
</script>

<style scoped>
.align-center {
  text-align: center;
}
.icon-principal {
  text-align: center;
  font-size: 5rem;
}
.margin-10 {
  margin: 10px;
}
.badge-input {
  background-color: #5A00D3 !important;
  color: #ffffff;
}
.badge-output {
  background-color: #D91500 !important;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// Monitoring.vue